<script>
	import { onMount } from 'svelte';
	import moment from 'moment';
    import {sgettext} from '../../i18n.js';
    import { PATH_PREFIX_ABS } from "../../apiUrls";

	export let deviceSyncStatusUrl =
		`http://localhost:8000${PATH_PREFIX_ABS}sw/v2/api/device/sync_status/`;
	export let deviceListUrl =
		`http://localhost:8000${PATH_PREFIX_ABS}sw/v2/api/device/devices/`;
	export let data = {
		columns: [
			{
				id: 'Device Name',
				label: sgettext('$$DEVICE_NAME$$'),
				fitContent: true,
			},
			{
				id: 'Instance Status',
				label: sgettext('$$INSTANCE_STATUS$$'),
				fitContent: true,
			},
			{
				id: 'Date',
				label: sgettext('$$DATE$$'),
				fitContent: true,
			},
		],
	};
	export let striped = true;
	let selectedRow = null;
	export let MAX_ATTEMPT_RETRY = null;
	export let instance_name = null;
	export let showHeader = true;

	let devicesStatus = [];

	function onRowClick(event) {
		const key = event.currentTarget.getAttribute('key');
		event.stopPropagation();
		event.currentTarget.classList.add('selected');

		const filtered = data.rows.filter((d) => d.id === key);
		if (filtered.length) {
			if (selectedRow) {
				selectedRow.selected = false;
			}
			selectedRow = filtered[0];
			selectedRow.selected = true;
		}
		data.rows = [...data.rows];
	}

	async function getDeviceStatus() {
		const response = await fetch(`${deviceSyncStatusUrl}`);
		const json = await response.json();
		try {
			if (response.ok) {
				if (json) {
					devicesStatus = json.results;
				}
			} else {
				console.error(json);
			}
		} catch (err) {
			console.error(err);
		}
	}

	function getUrl(id) {
		return `${location.protocol}//${location.host}${PATH_PREFIX_ABS}sw/mobile_device/device_management/${id}/device_instances/`;
	}

	async function getDeviceName(id) {
		const response = await fetch(`${deviceListUrl}${id}`);
		const json = await response.json();
		let deviceName = null;
		try {
			if (response.ok) {
				if (json) {
					deviceName = json.name;
				}
			} else {
				console.error(json);
			}
		} catch (err) {
			console.error(err);
		}
		return deviceName;
	}

	function transformDateTime(dateTime) {
		var formattedDateTime = moment(dateTime);
		if (formattedDateTime.isValid()) {
			return formattedDateTime.format('MMM. DD, YYYY, h:mm A.');
		} else {
			return 'N/A';
		}
	}

	onMount(async () => {
		await getDeviceStatus();
	});
</script>

<style>

	.instance-status {
		box-sizing: border-box;
		min-width: 95px;
		border-radius: 1rem;
		display: block;
		padding: 0.3em 0.6em 0.3em;
		font-size: 0.8rem;
		font-weight: 700;
		line-height: 1;
		text-align: center;
		white-space: normal;
		min-width: 69px;
	}

	.instance-status-pending {
		color: white;
		background-color: #dd5900;
	}

	.instance-status-failed {
		color: white;
		background-color: #181818;
	}

</style>

<div class="container">

  <h1 class="text-primary">{sgettext('$$DEVICES$$')}</h1>
  <p class="lead">
    {sgettext('$$DEVICES_ACTIVITY_ASSOCIATED_INSTANCE$$')} <b>{instance_name}</b>
  </p>

  <table class="table" class:table-striped={striped}>
    {#if data.hasOwnProperty('columns') && showHeader}
      <thead class="thead-light">
        <tr>
          {#each data.columns as col}
            <th class:fit={col.fitContent}>
              {col.label}
            </th>
          {/each}
        </tr>
      </thead>
    {/if}
    <tbody>
      {#each devicesStatus as ds}
        <tr on:click={onRowClick}>
          {#await getDeviceName(ds.device) then device}
            <td>
              <a href={getUrl(ds.device)}>{device}</a>
            </td>
          {/await}
          <td>
            {#if ds.attempt_number > MAX_ATTEMPT_RETRY }
              <span
                class="instance-status
                instance-status-failed">
                {sgettext('$$FAILED_1$$')}
              </span>
            {:else if ds.current_status === 1 && ds.desired_status === 1}
              <span
                class="instance-status
                instance-status-pending">
                {sgettext('$$DOWNLOADED$$')}
              </span>
            {:else if ds.current_status === 1 && ds.desired_status === 2}
              <span
                class="instance-status
                instance-status-pending">
                {sgettext('$$AWAITING_REMOVAL$$')}
              </span>
            {:else if ds.current_status === 2 && ds.desired_status === 1}
              <span
                class="instance-status
                instance-status-pending">
                {sgettext('$$AWAITING_DOWNLOAD$$')}
              </span>
            {:else if ds.current_status === 2 && ds.desired_status === 2}
              <span
                class="instance-status
                instance-status-pending">
                {sgettext('$$REMOVED$$')}
              </span>
            {:else}
              <span
                class="instance-status
                instance-status-failed">
                {sgettext('$$UNKNOWN_STATUS$$')}
              </span>
            {/if}
          </td>
          <td>
            {transformDateTime(ds.change_completed_datetime)}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>

</div>
